import React from 'react';
import heroPhoto from '../../assets/images/HeroPhoto.png';

export default function Hero({ scrollY }) {
  return (
    <section id="home" className="min-h-screen flex items-center justify-center px-4 md:px-6 py-20 md:py-0">
      <div className="max-w-6xl w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          {/* Text Content */}
          <div 
            className="transition-all duration-1000 text-center md:text-left"
            style={{
              opacity: Math.max(0, 1 - scrollY / 500),
              transform: `translateY(${scrollY * 0.3}px)`
            }}
          >
            <h1 className="font-cormorant text-5xl sm:text-6xl md:text-7xl lg:text-8xl xl:text-9xl font-bold leading-tight mb-4 md:mb-6">
              Erika<br />
              Hubbard
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-gray-600 font-light">
              Violinist
            </p>
          </div>

          {/* Image */}
          <div 
            className="transition-all duration-1000"
            style={{
              opacity: Math.max(0, 1 - scrollY / 500),
              transform: `translateY(${scrollY * 0.2}px)`
            }}
          >
            <img 
              src={heroPhoto} 
              alt="Erika Hubbard" 
              className="w-full max-w-md mx-auto md:max-w-full h-auto rounded-lg shadow-2xl"
            />
          </div>
        </div>
      </div>
    </section>
  );
}